import React from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'

import styles from './styles-legacy.scss'

import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { ResourcesBanner as ResourcesBannerDefault } from './component'

export const ResourcesBanner = (props: IProps): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) return <ResourcesBannerDefault {...props} />
  return <ResourcesBannerLegacy {...props} />
}

const ResourcesBannerLegacy = ({ heading, subHeading, leftImage, rightImage }: IProps) => {
  return (
    <div className="resources-banner__wrapper">
      <div className="resources-banner">
        <img className="banner-left-image" src={leftImage} alt="" />
        <div className="banner-middle-item">
          <h1 className="banner-middle-item__heading">
            <Text size="heading+">{heading}</Text>
          </h1>
          <div className="banner-middle-item__subheading">
            <Text size="md">{subHeading}</Text>
          </div>
        </div>
        <img className="banner-right-image" src={rightImage} alt="" />
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
